export default __webpack_public_path__ + "static/media/sensotrend_signin_check_email.8c52245a.png";